var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"small",attrs:{"role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.handleSelectAll.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.isSelectedAll ? 'Unselect' : 'Select')+" all\n")])}
var staticRenderFns = []

export { render, staticRenderFns }